import { createCurrentUser } from 'lib/helpers/createCurrentUser'; // TODO move all src/helpers to src/lib/helpers
import { AuthReducerState } from './types';

export const getDefaultState = (): AuthReducerState => ({
  currentUser: createCurrentUser(),
});
